/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  UPDATE_ACK_STATUS: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.update.ack',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'UPDATE_ACK_STATUS' },
      },
    },
    UPDATE_ACK_STATUS: {
      invoke: {
        id: 'updateAckStatus',
        src: 'updateAckStatus',
        onDone: {
          target: 'UPDATE_ACK_STATUS_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'UPDATE_ACK_STATUS_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    UPDATE_ACK_STATUS_SUCCESS: {
      on: {
        START: { target: 'UPDATE_ACK_STATUS' },
      },
    },
    UPDATE_ACK_STATUS_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
